export default "__VITE_ASSET__DYKznG1d__"